/* PILLAR cart extras — free-shipping progress bar + urgency notice.
   Threshold is the VISUAL indicator only; the real free-shipping rate lives in
   Shopify Settings > Shipping. Injected into block-level containers (cart page
   summary, mobile summary, cart drawer) so nothing stretches into a column. */
(function () {
  if (window.__pcuInit) return;
  window.__pcuInit = true;

  var THRESHOLD = 7500;

  var css =
    '.pillar-cart-extras{margin:0 0 16px;}' +
    '.cart-drawer .pillar-cart-extras{margin:2px 0 8px;}' +
    '.pillar-fsb{margin:0 0 13px;}' +
    '.pillar-fsb__msg{font-size:.8rem;letter-spacing:.02em;color:#343131;margin-bottom:9px;line-height:1.3;}' +
    '.pillar-fsb__msg strong{font-weight:600;}' +
    '.pillar-fsb__track{position:relative;height:4px;background:#e4e1da;border-radius:999px;}' +
    '.pillar-fsb__fill{position:absolute;left:0;top:0;height:100%;border-radius:999px;background:#343131;transition:width .55s cubic-bezier(.4,0,.2,1);}' +
    '.pillar-fsb__dot{position:absolute;right:0;top:50%;transform:translate(50%,-50%);width:11px;height:11px;border-radius:50%;background:#fff;border:2px solid #cfc8bd;transition:border-color .3s,background .3s;}' +
    '.pillar-fsb.is-met .pillar-fsb__fill{background:#3b6d11;}' +
    '.pillar-fsb.is-met .pillar-fsb__dot{background:#3b6d11;border-color:#3b6d11;}' +
    '.pillar-urgency{display:flex;align-items:center;gap:9px;background:#f3f2ee;color:#5b574f;font-size:.78rem;letter-spacing:.01em;line-height:1.3;padding:12px 15px;}' +
    '.pillar-urgency svg{flex:none;width:15px;height:15px;}';
  var st = document.createElement('style');
  st.id = 'pcu-css';
  st.textContent = css;
  (document.head || document.documentElement).appendChild(st);

  var CLOCK = '<svg viewBox="0 0 24 24" fill="none" stroke="#5b574f" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"></circle><path d="M12 7.5v4.5l3 1.8"></path></svg>';

  function money(c) { return '$' + (Math.round(c) / 100).toFixed(2).replace(/\.00$/, ''); }

  function buildHTML(total) {
    var met = total >= THRESHOLD;
    var pct = Math.max(4, Math.min(100, Math.round(total / THRESHOLD * 100)));
    var msg = met
      ? "You've unlocked <strong>free standard shipping</strong>"
      : "Only <strong>" + money(THRESHOLD - total) + "</strong> away from free standard shipping";
    return '<div class="pillar-fsb' + (met ? ' is-met' : '') + '">' +
        '<div class="pillar-fsb__msg">' + msg + '</div>' +
        '<div class="pillar-fsb__track"><div class="pillar-fsb__fill" style="width:' + pct + '%"></div><span class="pillar-fsb__dot"></span></div>' +
      '</div>' +
      '<div class="pillar-urgency">' + CLOCK + '<span>Items in bag are not held and may sell out</span></div>';
  }

  function place(container, total, afterEl) {
    var ex = container.querySelector(':scope > .pillar-cart-extras') || container.querySelector('.pillar-cart-extras');
    if (ex) { ex.innerHTML = buildHTML(total); return; }
    var wrap = document.createElement('div');
    wrap.className = 'pillar-cart-extras';
    wrap.innerHTML = buildHTML(total);
    if (afterEl && afterEl.parentNode === container && afterEl.nextSibling) container.insertBefore(wrap, afterEl.nextSibling);
    else container.insertBefore(wrap, container.firstChild);
  }

  function render(total) {
    var hasItems = document.querySelectorAll('.cart-item-list__body [data-merge-list-item], .cart-item-list__body .cart-item').length > 0;
    var side = document.querySelector('.cart-sidepanel');
    if (side && hasItems) place(side, total, null);
    var mob = document.querySelector('.mobile-only .checkout-subtotal-container:not(.hidden)');
    if (mob) place(mob, total, null);
    var upper = document.querySelector('.cart-drawer .cart-drawer__content-upper');
    if (upper) place(upper, total, upper.querySelector('.cart-drawer__header'));
  }

  function update() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { if (cart && typeof cart.total_price === 'number') render(cart.total_price); })
      .catch(function () {});
  }

  function fixCopy() {
    try {
      var walk = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
      var hits = [], n;
      while (n = walk.nextNode()) {
        if (!/50/.test(n.nodeValue)) continue;
        if (!/\$\s*50\b|\b50\+|\bover 50\b/i.test(n.nodeValue)) continue;
        var ctx = '', p = n.parentNode, hops = 0;
        while (p && hops < 3) { ctx += ' ' + (p.textContent || ''); hops++; p = p.parentNode; }
        if (/ship/i.test(ctx)) hits.push(n);
      }
      hits.forEach(function (node) {
        node.nodeValue = node.nodeValue.replace(/\$\s*50\b/g, '$75').replace(/\bover 50\b/gi, 'over 75').replace(/\b50\+/g, '75+');
      });
    } catch (e) {}
  }

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(update);
  ready(fixCopy);
  setTimeout(fixCopy, 1200);
  setTimeout(fixCopy, 2600);
  ['cart:updated', 'cart:refresh', 'cart:build', 'theme:cart-change', 'ajaxProduct:added'].forEach(function (e) {
    document.addEventListener(e, function () { setTimeout(update, 160); });
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('a[href$="/cart"],.cart-link,[name="add"],.quickbuy-toggle,.cart-item__remove,.quantity-selector')) setTimeout(update, 650);
  });
  var n = 0, iv = setInterval(function () { n++; update(); if (n > 16) clearInterval(iv); }, 1000);
})();
